"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.renameAttribute = ({ step, log, parentTimestamp, el, }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const ignoreWarning = true;
    const tagJsx = react_1.default.createElement("code", null,
        "<",
        el.tagName.toLowerCase(),
        " />");
    if (!el.hasAttribute(step.fromAttribute)) {
        log('error', {
            message: (react_1.default.createElement(react_1.default.Fragment, null,
                tagJsx,
                " has no attribute matching [",
                step.fromAttribute,
                "].")),
            parentTimestamp,
        });
        return el;
    }
    if (el.hasAttribute(step.toAttribute) && !ignoreWarning) {
        log('warn', {
            message: (
            //   <>
            //     {tagJsx} has its attribute <code>[{action.fromAttribute}]</code>{' '}
            //     being renamed to <code>[{action.toAttribute}]</code>, which is
            //     already set. This conversion step may be replacing data. If this is
            //     intended, add <code>[osys:rename:attr:ignorewarning]</code> to
            //     silence this warning.
            //   </>
            react_1.default.createElement(react_1.default.Fragment, null,
                tagJsx,
                " has its attribute ",
                react_1.default.createElement("code", null,
                    "[",
                    step.fromAttribute,
                    "]"),
                " being renamed to ",
                react_1.default.createElement("code", null,
                    "[",
                    step.toAttribute,
                    "]"),
                ", which is already set. This conversion step may be replacing data. Please contact Osmosys support to silence this warning.")),
            parentTimestamp,
        });
    }
    el.setAttribute(step.toAttribute, el.getAttribute(step.fromAttribute));
    log('success', {
        message: (react_1.default.createElement(react_1.default.Fragment, null,
            "Renamed the attribute for ",
            tagJsx,
            " from",
            ' ',
            react_1.default.createElement("code", null,
                "[",
                step.fromAttribute,
                "]"),
            " to ",
            react_1.default.createElement("code", null,
                "[",
                step.toAttribute,
                "]"),
            ".")),
        parentTimestamp,
    });
    return el;
});
//# sourceMappingURL=renameAttribute.js.map